<template>
  <CellListInstantPlayCatalog
    key="infinite_cell_list_instant_play"
    :cell-list="cellList"
    :thumbnail-info="thumbnailInfo"
    :container-class-name="containerClassName"
  />
</template>
<script setup lang="ts">
  import { computed, defineProps } from 'vue'
  import { previewCell } from '@/common/util/like-status/preview-cell'
  import { comingSoonCell } from '@/common/util/coming-soon/coming-soon-cell'
  import CellListInstantPlayCatalog from '@/components/section/template/cell/cell-catalog/CellListInstantPlayCatalog'

  const props = defineProps({
    contextList: {
      type: Array,
      default: () => [],
      required: true,
    },
    thumbnailInfo: {
      type: Object,
      default: () => {},
      required: true,
    },
    containerClassName: {
      type: String,
      default: '',
    },
    isComingSoon: {
      type: Boolean,
      default: false,
    },
  })

  const cellList = computed(() => {
    const convertedCellList = previewCell(props.contextList)
    return props.isComingSoon
      ? comingSoonCell(convertedCellList)
      : convertedCellList
  })
</script>
